
import { Injectable } from '@angular/core';

@Injectable()
export class ScrollingService {

  constructor() {};

  public scrollToFragment(fragment: string, timeout: number = 10) {
    const appHeader = document.getElementsByTagName('app-header')[0];
    const mobileDropDown = document.getElementsByTagName('mobile-dropdown')[0];
    const bottomOfAppHeader = appHeader.getBoundingClientRect().bottom - mobileDropDown.getBoundingClientRect().height;
    setTimeout(() => {
      const element = document.querySelector('#' + fragment);
      if (element) {
        element.scrollIntoView(true);
        const currentYPosition = window.pageYOffset;
        window.scrollTo(0, (currentYPosition - bottomOfAppHeader));
      } else {
        this.scrollToTop();
      }
    }, timeout);
  }

  public scrollToTop() {
    window.scrollTo(0, 0);
  }
}
